import React from 'react';
import { Content, Title } from './StrikeZoneExplanationsStyles';

const Static = () => {
  return (
    <div>
      <Title>Static SZ</Title>
      <Content>Is set based on the never-changing (static) definition set for this game.</Content>
    </div>
  );
};

export default Static;
